module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/Quiz_2.3_12.48bb0c68.pdf";